import React from 'react';

export default function SummaryHeaderCell(cellHeader, currencyName) {
    if (cellHeader.column.dataField == 'yield')
        return (
            <div className="positionColumnHeader">Доходность<br />за период</div>
        );

    if (cellHeader.column.dataField == 'totalYield')
        return (
            <div className="positionColumnHeader">Доходность<br />с начала инвестирования</div>
        );

    if (cellHeader.column.dataField == 'rateInCurrency')
        return (
            <div className="positionColumnHeaderRight">Оценка портфеля<br />(в базовой валюте {currencyName})</div>
        );

    return (
        <div className="positionColumnHeader">{cellHeader.column.caption}</div>
    );
}


// WEBPACK FOOTER //
// ./App/containers/summary/summaryHeaderCell.jsx